import React, { useState } from "react";
import CrossAttachmentAssessment from "../../Attachment/CrossAttachmentAssessment";
// css comes in create_hw_file.css in homework
import axios from "../../../../../axios";

const CreateUploadType = ({ question, nextQuestion, setQuestions }) => {
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const [isValidFileType, setIsValidFileType] = useState(true);
  const [loader, setLoader] = useState(false);

  const handleReasonChange = (index, value) => {
    setQuestions((prev) => {
      const updatedCorrectAnswer = prev[nextQuestion].correct_answers.map(
        (answer, i) =>
          i === index
            ? {
              ...answer,
              reason_for_answer: {
                ...answer.reason_for_answer,
                explanation: value,
              },
            }
            : answer
      );

      const updatedQuestion = {
        ...prev[nextQuestion],
        correct_answers: updatedCorrectAnswer,
      };

      const newQuestions = [...prev];
      newQuestions[nextQuestion] = updatedQuestion;
      return newQuestions;
    });
  };

  const validateFileType = (filePath) => {
    var allowedExtensions =
      /(\.jpg|\.jpeg|\.png|\.pdf|\.mp3|\.mp4|\.pptx|\.ppt)$/i;

    if (!allowedExtensions.exec(filePath.name)) {
      setIsValidFileType(false);
      return false;
    }
    setIsValidFileType(true);
    return true;
  };

  const handleAttachmentChange = async (index, file) => {
    if (file) {
      try {
        setLoader(true)
        if ((file.size < 10 * 1024 * 1024) && validateFileType(file)) {
          let formData = new FormData();
          formData.append("name", file.name);
          formData.append("uploadQuestionAttachment", file);
          let res = await axios.post(
            `/api/v1/question/uploadAttachment/teacherId/${teacher_id}`,
            formData
          );
          res && setLoader(false);
          res &&
            setQuestions((prev) => {
              const updatedCorrectAnswer = prev[nextQuestion].correct_answers.map(
                (answer, i) =>
                  i === index
                    ? {
                      ...answer,
                      reason_for_answer: {
                        ...answer.reason_for_answer,
                        attachment: res.data.data,
                      },
                    }
                    : answer
              );

              const updatedQuestion = {
                ...prev[nextQuestion],
                correct_answers: updatedCorrectAnswer,
              };

              const newQuestions = [...prev];
              newQuestions[nextQuestion] = updatedQuestion;
              return newQuestions;
            });
        } else {
          setIsValidFileType(false);
        }
      } catch (error) {
        setLoader(false)
        console.log(error);
      }
    }
  };
  return (
    <>
      <div className="col-12 ml-1">
        <div className="hw_mandatory_checkbox ml-1 mt-3">
          Add correct answer
        </div>
        {question.correct_answers.length > 0 &&
          question.correct_answers.map((cAnswer, index) => (
            <div key={index}>
              <div className="hw_mcq_option_box d-flex align-items-center">
                <input
                  onChange={(e) => handleReasonChange(index, e.target.value)}
                  // className="hw_mcq_option_box mt-2"
                  className="hw_add_reason"
                  placeholder=""
                  maxLength={250}
                  value={cAnswer.reason_for_answer.explanation}
                />
                <div>
                  <input
                    onChange={(e) => {
                      handleAttachmentChange(index, e.target.files[0]);
                    }}
                    type="file"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    id={`attachFileForReason${nextQuestion}`}
                    style={{ display: "none" }}
                  />
                  <label
                    style={{
                      backgroundColor: "#F0F0F0",
                      borderRadius: "8px",
                      cursor: "pointer",
                      margin: 0,
                    }}
                    className="d-flex align-items-center py-2 px-3"
                    htmlFor={`attachFileForReason${nextQuestion}`}
                  >
                    <img src="images/Attach.svg" alt="" />
                    <span className="hw_mandatory_checkbox">&nbsp;Attach</span>
                  </label>
                </div>
              </div>
              {cAnswer.reason_for_answer.attachment && (
                <div style={{ display: "flex", justifyContent: "flex-end", width: "98%" }} className="mt-2">
                  <CrossAttachmentAssessment
                    // key={idx}
                    attachment={cAnswer.reason_for_answer.attachment}
                    isReasonForAnswer={true}
                    isEditable={true}
                    setQuestions={setQuestions}
                    nextQuestion={nextQuestion}
                  />
                </div>
              )}
              {loader && <img style={{ width: "32px", height: "32px" }} src="/gif/Loader.gif" />}

              {!isValidFileType && (
                <p id="errorMsg">
                  Please upload a file with a valid extension (pdf, jpg, jpeg, png, pptx, ppt, mp3, mp4), Max Limit = 5.
                </p>
              )}
            </div>
          ))}
      </div>
    </>
  );
};

export default CreateUploadType;
